import { formatConnectorName, isConnectorId, } from '#pplx/frontend/apps/ask/files/file-utils/fileUtils.js';
import { toTitleCase } from '#pplx/frontend/apps/ask/shared-helpers/stringUtils.js';
import { CORE_SOURCES, isCoreSourceType, } from '#pplx/frontend/apps/ask/sources/coreSourcesConfig.js';
import { getCometMcpServerName, isCometMcpSourceType, } from '#pplx/frontend/apps/ask/sources/types/cometMcpSourceTypes.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
const PIPEDREAM_SOURCE_ID_SUFFIX = '__pipedream';
const SOURCE_LABEL_OVERRIDES = {
    linkedin: 'LinkedIn',
};
export const getFallbackSourceLabel = (sourceId) => {
    const displaySourceId = sourceId.endsWith(PIPEDREAM_SOURCE_ID_SUFFIX)
        ? sourceId.slice(0, -PIPEDREAM_SOURCE_ID_SUFFIX.length)
        : sourceId;
    return SOURCE_LABEL_OVERRIDES[displaySourceId] ?? toTitleCase(displaySourceId);
};
/**
 * @deprecated use getSourceLabel from useSources instead
 */
export const useSourceLabel = ({ cometMcpSources, }) => {
    const intl = useIntl();
    const getSourceLabel = useCallback((sourceType) => {
        const defaultLabel = getFallbackSourceLabel(sourceType);
        if (isCoreSourceType(sourceType)) {
            return CORE_SOURCES[sourceType].label(intl);
        }
        if (isCometMcpSourceType(sourceType)) {
            const serverName = getCometMcpServerName(sourceType);
            return cometMcpSources[serverName]?.text ?? serverName;
        }
        if (isConnectorId(sourceType)) {
            return formatConnectorName(sourceType) ?? defaultLabel;
        }
        return defaultLabel;
    }, [intl, cometMcpSources]);
    return getSourceLabel;
};
//# sourceMappingURL=useSourceLabel.js.map